import React from 'react';
import classNames from 'classnames';

import css from './IconRefrigerator.module.css';

/**
 * IconRefrigerator icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconRefrigerator = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5.99916 0C4.59655 0 3.42773 1.11749 3.42773 2.53478V9.21538C3.44399 9.21466 3.46032 9.21429 3.47675 9.21429H20.5216C20.538 9.21429 20.5543 9.21466 20.5706 9.21538V2.53478C20.5706 1.11749 19.4018 0 17.9992 0H5.99916ZM3.42773 19.3111V11.356C3.44399 11.3568 3.46032 11.3571 3.47675 11.3571H20.5216C20.538 11.3571 20.5543 11.3568 20.5706 11.356V19.3111C20.5706 20.5812 19.632 21.6105 18.4277 21.8107V22.7031C18.4277 23.4132 17.8521 23.9889 17.142 23.9889C16.4319 23.9889 15.8563 23.4132 15.8563 22.7031V21.846H8.14202V22.7031C8.14202 23.4132 7.56638 23.9889 6.85631 23.9889C6.14623 23.9889 5.57059 23.4132 5.57059 22.7031V21.8107C4.36629 21.6105 3.42773 20.5812 3.42773 19.3111ZM8.64132 4.47305C8.64132 3.88133 8.16163 3.40162 7.56989 3.40162C6.97816 3.40162 6.49847 3.88133 6.49847 4.47305V5.33019C6.49847 5.92193 6.97816 6.40162 7.56989 6.40162C8.16163 6.40162 8.64132 5.92193 8.64132 5.33019V4.47305Z" fill="#262338"/>
</svg>

  );
};

export default IconRefrigerator;
